import { create } from "zustand";
import { devtools } from "zustand/middleware";

type LoadingState = {
  isLoading: boolean;
  loadingCount: number;
  startLoading: () => void;
  stopLoading: () => void;
}

export const useLoadingStore = create(
  devtools<LoadingState>((set) => ({
    isLoading: false,

    loadingCount: 0,

    startLoading: () =>
      set((state) => ({
        loadingCount: state.loadingCount + 1,
        isLoading: true,
      })),

    stopLoading: () =>
      set((state) => {
        const newCount = state.loadingCount - 1;
        return {
          loadingCount: Math.max(0, newCount),
          isLoading: newCount > 0,
        };
      }),
  }))
);
